var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpCentre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Help_Centre",
    "data-name": "Help Centre",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3360",
    "data-name": "Rectangle 3360",
    width: 16,
    height: 16,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3553",
    "data-name": "Group 3553",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M16,7.531v.937a1.339,1.339,0,0,0-.027.151,7.579,7.579,0,0,1-.62,2.533A7.979,7.979,0,0,1,7.946,16Q4.338,16,.73,16A.643.643,0,0,1,0,15.27q0-3.608,0-7.217A7.762,7.762,0,0,1,.938,4.247,7.879,7.879,0,0,1,6.606.126C6.911.068,7.222.041,7.531,0h.937a.841.841,0,0,0,.121.026,7.533,7.533,0,0,1,3.167.914,7.885,7.885,0,0,1,4.117,5.668c.058.3.085.616.126.924M1.25,14.749h.206q3.21,0,6.42,0a7.575,7.575,0,0,0,.981-.059A6.583,6.583,0,0,0,13.638,11.7a6.448,6.448,0,0,0,1.051-4.551,6.569,6.569,0,0,0-3.01-4.8A6.487,6.487,0,0,0,7.139,1.31,6.567,6.567,0,0,0,2.783,3.723,6.621,6.621,0,0,0,1.249,8.092q.006,3.234,0,6.467v.19",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M110.033,82.009a2.723,2.723,0,0,1,1.607.481,1.646,1.646,0,0,1,.509,2.088,3.291,3.291,0,0,1-.827,1.044c-.169.146-.341.29-.5.446a1.048,1.048,0,0,0-.31.713c-.007.135-.01.271-.022.405a.374.374,0,0,1-.326.38,1.763,1.763,0,0,1-.479.027.418.418,0,0,1-.408-.436,2.09,2.09,0,0,1,.759-1.974,6.887,6.887,0,0,0,.655-.576,1,1,0,0,0,.23-.416.678.678,0,0,0-.57-.889,2.653,2.653,0,0,0-.711-.011.752.752,0,0,0-.537.315c-.06.078-.117.159-.177.238a.519.519,0,0,1-.684.189.586.586,0,0,1-.371-.637,1.53,1.53,0,0,1,1.01-1.173,2.855,2.855,0,0,1,1.153-.215",
    transform: "translate(-102.11 -77.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M129.974,201.917a.838.838,0,0,1,.833-.833.839.839,0,0,1-.012,1.678.835.835,0,0,1-.821-.844",
    transform: "translate(-123.042 -190.36)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCentre);
export default __webpack_public_path__ + "static/media/Help Centre.1d2bb12d51034e0ecd27cd1a34f5a9e3.svg";
export { ForwardRef as ReactComponent };